export const APP_VERSION = '2.6.2';
export const APP_BUILD_DATE = '26 Octombrie 2026';
export const APP_BUILD_TAG = 'Formatare Studio 16:9 Dinamică Proporțională (4, 6, 8, 12, 16 carduri fără alungire), Pillarbox 9:16 Ecrane Mobile';

